import { headerStyles as styles } from "@iewccouk/Overrides/Widgets/OrderConfirmation/OrderConfirmationHeader";
import { css } from "styled-components";

styles.continueButton = {
    ...styles.continueButton,
    css: css`
        ${styles.continueButton?.css}
        span {
            pointer-events: none;
        }
    `,
};
